import { render, staticRenderFns } from "./SchoolYearSwitch.vue?vue&type=template&id=4943d504&scoped=true&"
import script from "./SchoolYearSwitch.vue?vue&type=script&lang=ts&"
export * from "./SchoolYearSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolYearSwitch.vue?vue&type=style&index=0&id=4943d504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4943d504",
  null
  
)

export default component.exports